export default __webpack_public_path__ + "static/media/Gear.2fb3dfc3.gif";